module.exports = __webpack_public_path__ + "img/content-yellow2.e5a4e9c8.png";